import { SVGProps } from 'react'

const ExchangeIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='16' height='15' viewBox='0 0 16 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                d='M10.4438 13.002L12.8879 10.5579L10.4438 8.11385'
                stroke='#959699'
                strokeWidth='1.22203'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.888 10.5581H3.11182'
                stroke='#959699'
                strokeWidth='1.22203'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.55587 2.00252L3.11182 4.44657L5.55587 6.89062'
                stroke='#959699'
                strokeWidth='1.22203'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M3.11182 4.44971L12.888 4.44971'
                stroke='#959699'
                strokeWidth='1.22203'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
export default ExchangeIcon
